import { SpsIcon } from "@spscommerce/ds-shared";
import * as React from "react";

import {
    SpsWf,
    SpsWfDoc,
    SpsWfDs,
    SpsWfStep,
    SpsWorkflow,
    SpsWorkflowDocument,
    SpsWorkflowDocumentStatus,
    SpsWorkflowStep,
} from "../index";

export class SpsWorkflowBasic extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static reactLive = {
        code: `
        <div className="col-4">
            <SpsWorkflow icon="list-summary" title="Workflow">
              <SpsWorkflowStep icon="heart" title="Name of Step">
                <SpsWorkflowDocument>
                    <a href="https://github.com/SPSCommerce/ui-angular" target="_blank">
                      Document Name
                    </a>
                    <SpsWorkflowDocumentStatus icon="status-error">Status</SpsWorkflowDocumentStatus>
                </SpsWorkflowDocument>
                <SpsWorkflowDocument>
                    Document Name
                    <SpsWorkflowDocumentStatus>Status</SpsWorkflowDocumentStatus>
                </SpsWorkflowDocument>
              </SpsWorkflowStep>
              <SpsWorkflowStep icon="heart" title="Done">
              </SpsWorkflowStep>
            </SpsWorkflow>
        </div>
        `
    }

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <div className="col-4">
                <SpsWorkflow data-testid={testId} icon={SpsIcon.LIST_SUMMARY} title="Workflow">
                    <SpsWorkflowStep data-testid={testId} icon={SpsIcon.HEART} title="Name of Step">
                        <SpsWorkflowDocument data-testid={testId}>
                            <a href="https://github.com/SPSCommerce/ui-angular" target="_blank">
                                Document Name
                            </a>
                            <SpsWorkflowDocumentStatus data-testid={testId} icon={SpsIcon.STATUS_ERROR}>Status</SpsWorkflowDocumentStatus>
                        </SpsWorkflowDocument>
                        <SpsWorkflowDocument data-testid={testId}>
                            Document Name
                            <SpsWorkflowDocumentStatus>Status</SpsWorkflowDocumentStatus>
                        </SpsWorkflowDocument>
                    </SpsWorkflowStep>
                    <SpsWorkflowStep data-testid={testId} icon={SpsIcon.HEART} title="Done">
                    </SpsWorkflowStep>
                </SpsWorkflow>
            </div>
        )
    }
}

export class SpsWorkflowBasic1 extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static testId = "sps-feedback-block-tip";
    static reactLive = {
        code: `
        <div className="col-4">
            <SpsWf icon="list-summary" title="Workflow">
                <SpsWfStep icon="heart" title="Name of Step">
                    <SpsWfDoc>
                        <a href="https://github.com/SPSCommerce/ui-angular" target="_blank">
                            Document Name
                        </a>
                        <SpsWfDs icon="status-error">Status</SpsWfDs>
                    </SpsWfDoc>
                    <SpsWfDoc>
                        Document Name
                        <SpsWfDs>Status</SpsWfDs>
                    </SpsWfDoc>
                </SpsWfStep>
                <SpsWfStep icon="heart" title="Done">
                </SpsWfStep>
            </SpsWf>
        </div>
        `
    }

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <div className="col-4">
                <SpsWf icon={SpsIcon.LIST_SUMMARY} title="Workflow">
                    <SpsWfStep icon={SpsIcon.HEART} title="Name of Step">
                        <SpsWfDoc>
                            <a href="https://github.com/SPSCommerce/ui-angular" target="_blank">
                                Document Name
                            </a>
                            <SpsWfDs icon={SpsIcon.STATUS_ERROR}>Status</SpsWfDs>
                        </SpsWfDoc>
                        <SpsWfDoc>
                            Document Name
                            <SpsWfDs>Status</SpsWfDs>
                        </SpsWfDoc>
                    </SpsWfStep>
                    <SpsWfStep icon={SpsIcon.HEART} title="Done">
                    </SpsWfStep>
                </SpsWf>
            </div>
        )
    }
}